import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, Checkbox, Chip } from '@mui/material';
import { dotNotationExtractor, isFunction } from 'utils/functions';
import { formatter } from 'constantes/constants';

function Row({ columns, data = {}, checked = false, setCheck, visibleColumns, columnWidths }) {
  return (
    <TableRow hover onClick={() => setCheck(data)} selected={checked}>
      <TableCell padding="checkbox">
        <Checkbox checked={checked} disabled={data.selectable ? Boolean(data.selectable) : false} />
      </TableCell>
      {columns
        .filter(col => !visibleColumns || visibleColumns.includes(col.name) || !col.name)
        .map((col, index) => {
        let cellContent = col.component || dotNotationExtractor(data, col.name);
        cellContent = isFunction(cellContent) ? cellContent(data) : cellContent;
        cellContent = col.type === 'number' ? formatter.format(cellContent ?? 0) : cellContent;
        
                    // Manejar campos booleanos automáticamente
            if (col.filterType === 'boolean') {
                          // Convertir cualquier valor a booleano de manera robusta
            // Compatible con campos bool (true/false) y tinyint (0/1)
            let booleanValue = false;
            
            if (typeof cellContent === 'boolean') {
              // Valor ya es booleano
              booleanValue = cellContent;
            } else if (typeof cellContent === 'number') {
              // Valor numérico (0, 1, etc.)
              booleanValue = Boolean(cellContent);
            } else if (typeof cellContent === 'string') {
              // Valor string ("0", "1", "true", "false", etc.)
              const trimmedValue = cellContent.trim().toLowerCase();
              booleanValue = ['1', 'true', 'yes', 'sí', 'on', 'active'].includes(trimmedValue);
            } else if (cellContent === null || cellContent === undefined) {
              // Valor nulo o indefinido
              booleanValue = false;
            } else {
              // Otros tipos (array, object, etc.)
              booleanValue = Boolean(cellContent);
            }

              const booleanOptions = col.booleanOptions || { true: 'Sí', false: 'No' };
              const displayValue = booleanOptions[booleanValue] || cellContent;

              // Si no hay componente personalizado, renderizar chip automáticamente
              if (!col.component) {
                const chipColor = booleanValue ? 'success' : 'error';
                cellContent = (
                  <Chip
                    label={displayValue}
                    color={chipColor}
                    size="small"
                    variant="outlined"
                  />
                );
              } else {
                // Si hay componente personalizado, usar el valor de texto para el componente
                cellContent = displayValue;
              }
            }
        const columnWidth = columnWidths[index] || col.width || 150;
        return (
          <TableCell
            key={`Col${String(index)}`}
            align={col.align || 'left'}
            style={{ width: columnWidth }}
          >
            {cellContent}
          </TableCell>
        );
      })}
    </TableRow>
  );
}

Row.propTypes = {
  columns: PropTypes.oneOfType([PropTypes.array]).isRequired,
  data: PropTypes.oneOfType([PropTypes.object]),
  checked: PropTypes.bool,
  setCheck: PropTypes.func,
  visibleColumns: PropTypes.arrayOf(PropTypes.string),
  columnWidths: PropTypes.object
};

export default Row;
